const rarityNumericToTextual = {
  1: 'Common',
  2: 'Uncommon',
  3: 'Rare',
  4: 'Very Rare',
  5: 'Legendary',
  6: 'Artifact',
};

module.exports = {
  /**
   * Convert a numeric size to a textual one
   * @param {number} numericSize Numeric size
   * @returns {string} Textual size
   **/
  numericRarityToTextual(numericSize) {
    return rarityNumericToTextual[numericSize];
  },
};
